import { AppLayout } from "@bcc/components/app-layout";
import { PreferencesView } from "@bcc/components/views/preferences-view";

export function PreferencesPage() {
  return (
    <AppLayout>
      <PreferencesView />
    </AppLayout>
  );
}
